import React, { useState, useEffect, useMemo } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

const MY_SITE_KEY = '6LehBf8kAAAAADMl5VKp9ImCrNtdKLQfGGrHemmm'

const Contact = () => {
  const [phoneNumber, setPhoneNumber] = useState('')
  const [phoneNumberError, setPhoneNumberError] = useState('')
  const [formError, setFormError] = useState('')
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [recaptchaValue, setRecaptchaValue] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [isFormValid, setIsFormValid] = useState(false)
  const [formStartTime, setFormStartTime] = useState(null)
  const [userInteracted, setUserInteracted] = useState(false)

  const validPhoneNumber = useMemo(() => /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, [])
  useEffect(() => {
    // Validate the form when phoneNumber or recaptchaValue changes
    setIsFormValid(validPhoneNumber.test(phoneNumber) && !!recaptchaValue)
  }, [phoneNumber, recaptchaValue, validPhoneNumber])

  useEffect(() => {
    setFormStartTime(Date.now())

    const handleUserInteraction = () => setUserInteracted(true)

    window.addEventListener('mousemove', handleUserInteraction)
    window.addEventListener('keydown', handleUserInteraction)
    window.addEventListener('touchstart', handleUserInteraction)

    return () => {
      window.removeEventListener('mousemove', handleUserInteraction)
      window.removeEventListener('keydown', handleUserInteraction)
      window.removeEventListener('touchstart', handleUserInteraction)
    }
  }, [])

  const handlePhoneNumberChange = e => {
    setPhoneNumber(e.target.value)
    setPhoneNumberError('')
  }

  const handleRecaptchaChange = value => {
    setRecaptchaValue(value)
  }

  const handleSubmit = event => {
    event.preventDefault()
    if (submitting) return // Prevent double form submission

    const elapsedTime = Date.now() - formStartTime
    if (elapsedTime < 5000) {
      // Require at least 5 seconds before submission

      return
    }

    if (!userInteracted) {
      // Ensure the user interacted with the form

      return
    }

    if (!validPhoneNumber.test(phoneNumber)) {
      setPhoneNumberError('Invalid Phone Number')
      setIsFormValid(false)
      return
    }

    if (!recaptchaValue) {
      setFormError('Please complete the reCAPTCHA')
      setIsFormValid(false)
      return
    }

    setIsFormValid(true)
    setSubmitting(true)

    const formData = new FormData(event.target)
    formData.append('recaptchaValue', recaptchaValue)

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formData).toString(),
    })
      .then(response => {
        // Check if the form submission triggered a redirect to the thank you page
        if (response.ok) {
          console.log('Form submitted successfully')
          setFormSubmitted(true)
        } else {
          // Form submission failed
          console.error('Form submission failed:', response.statusText)
        }
      })
      .catch(error => {
        console.error('An error occurred during form submission:', error)
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  if (formSubmitted) {
    return <div>Thank you for your submission!</div>
  }

  const isButtonDisabled = submitting || !isFormValid

  return (
    <div>
      <form
        name="contact-form"
        method="POST"
        // eslint-disable-next-line react/no-unknown-property
        data-netlify-honeypot="comment"
        data-netlify="true"
        data-netlify-recaptcha="true"
        onSubmit={handleSubmit}
      >
        <input type="hidden" name="form-name" value="contact-form" />
        <input name="comment" style={{ position: 'absolute', right: '-100%' }} />
        <input
          type="hidden"
          name="subject"
          value="Web form submission for www.phildibelloroofing.com"
        />
        <input
          style={{
            display: 'block',
            border: '1px solid #6e6e6e',
            padding: '10px',
            margin: '10px 0',
            width: '100%',
          }}
          type="text"
          name="fullName"
          placeholder="Full name"
          required
        />
        <input
          style={{
            display: 'block',
            border: '1px solid #6e6e6e',
            padding: '10px',
            margin: '10px 0',
            width: '100%',
          }}
          type="email"
          name="emailAddress"
          placeholder="Email"
          required
        />
        <input
          style={{
            display: 'block',
            border: '1px solid #6e6e6e',
            padding: '10px',
            margin: '10px 0',
            width: '100%',
          }}
          type="tel"
          name="phoneNumber"
          placeholder="Phone #"
          required
          value={phoneNumber}
          onChange={handlePhoneNumberChange}
        />

        <fieldset name="requiredServicesGroup[]">
          <h3>Required Services</h3>
          <ul style={{ listStyleType: 'none' }}>
            <li>
              <input type="checkbox" name="services[]" value="roofing" /> Roofing
            </li>
            <li>
              <input type="checkbox" name="services[]" value="windows" /> Windows
            </li>
            <li>
              <input type="checkbox" name="services[]" value="siding" /> Siding
            </li>
            <li>
              <input type="checkbox" name="services[]" value="gutters" /> Gutters
            </li>
            <li>
              <input type="checkbox" name="services[]" value="skylights" /> Skylights
            </li>
            <li>
              <input type="checkbox" name="services[]" value="ventilation" /> Ventilation
            </li>
            <li>
              <input type="checkbox" name="services[]" value="roofInspection" /> Roof Inspection
            </li>
            <li>
              <input type="checkbox" name="services[]" value="financing" /> Financing
            </li>
            <li>
              <input type="checkbox" name="services[]" value="insuranceQuote" /> Insurance Quote
            </li>
            <li>
              <input type="checkbox" name="services[]" value="other" /> Other
            </li>
          </ul>
        </fieldset>
        <fieldset name="locationsGroup[]">
          <h3>Locations</h3>
          <ul style={{ listStyleType: 'none' }}>
            <li>
              <input type="checkbox" name="locations[]" value="baltimoreCity" /> Baltimore City
            </li>
            <li>
              <input type="checkbox" name="locations[]" value="baltimoreCounty" /> Baltimore County
            </li>
            <li>
              <input type="checkbox" name="locations[]" value="harfordCounty" /> Harford County
            </li>
            <li>
              <input type="checkbox" name="locations[]" value="howardCounty" /> Howard County
            </li>
            <li>
              <input type="checkbox" name="locations[]" value="carrollCounty" /> Carroll County
            </li>
            <li>
              <input type="checkbox" name="locations[]" value="anneArnudelCounty" /> Anne Arundel
              County
            </li>
            <li>
              <input type="checkbox" name="locations[]" value="anneArnudelCounty" /> Prince George
              County
            </li>
            <li>
              <input type="checkbox" name="locations[]" value="anneArnudelCounty" /> Frederick
              County
            </li>
            <li>
              <input type="checkbox" name="locations[]" value="anneArnudelCounty" /> Other
            </li>
          </ul>
        </fieldset>
        <textarea
          style={{
            width: '100%',
            display: 'block',
            border: '1px solid #6e6e6e',
            padding: '10px',
            margin: '10px 0',
          }}
          name="message"
          placeholder="Tell Us How We Can Help You"
          required
        />
        {phoneNumberError && <p>{phoneNumberError}</p>}
        {formError && <p>{formError}</p>}
        <ReCAPTCHA sitekey={MY_SITE_KEY} onChange={handleRecaptchaChange} />
        <button
          style={{
            backgroundColor: '#D52924',
            color: '#fff',
            padding: '10px 30px',
            margin: '20px 0',
            WebkitAppearance: 'none',
            cursor: isButtonDisabled ? 'not-allowed' : 'pointer',
          }}
          type="submit"
          disabled={isButtonDisabled}
        >
          {submitting ? 'Submitting...' : 'Submit'}
        </button>
      </form>
    </div>
  )
}

export default Contact
